import React from 'react';

import styles from './IconSuccess.module.scss';
import Icon from './Icon';

type IconSuccessProps = {
  className?: string;
  testId?: string;
};

function IconSuccess({ className = '', testId }: IconSuccessProps) {
  return (
    <Icon
      icon="check-circle"
      className={[styles.icon, className].join(' ')}
      testId={testId}
    />
  );
}

export default IconSuccess;
